"use client";

import { useEffect } from "react";

const DisableZoom = () => {
  useEffect(() => {
    // iOS Safari emits "gesturestart" events, not officially in TS DOM lib
    const handler = (e: Event) => {
      const gesture = e as unknown as {
        scale?: number;
        preventDefault: () => void;
      };
      if (gesture.scale && gesture.scale !== 1) {
        gesture.preventDefault();
      }
    };

    document.addEventListener("gesturestart", handler);
    return () => document.removeEventListener("gesturestart", handler);
  }, []);

  return null;
};

export default DisableZoom;
